import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiHelperFunction from "../../api";

interface BppState {
  status: "idle" | "loading" | "succeeded" | "failed";
  mercuryData: any;
  error: string;
}

const initialState: BppState = {
  status: "idle",
  mercuryData: null,
  error: "",
};


export const getMerecryDetailUrl = createAsyncThunk(
  "user/mercury-referral/",
  async (_, { dispatch }) => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await ApiHelperFunction({
        url: "/api/v1/user/mercury-referral/",
        method: "get",
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      return response;
    } catch (error: any) {}
  },
);
export const bppSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    restAll: (state) => {
      state.error = "";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getMerecryDetailUrl.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getMerecryDetailUrl.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.dataList = action.payload?.data || [];

        // state.UserResponse = action.payload || [];
      })
      .addCase(getMerecryDetailUrl.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});
